import React, { useContext, useEffect, useState } from "react";
import * as S from "./ModalNovoSaqueStyle";
import axios from "axios";
import Loading from "../Loader";
import { AuthContext } from "../../Context/AuthContext";
import { formatNumber } from "../ASSETS/assets";
import { FaTimes } from "react-icons/fa";
import { useMessage } from "../../Context/MessageContext";

const base_url = process.env.REACT_APP_API_BASE_URL;

export default function ModalNovoSaque({ setModalNovoSaque, fetchSaques }) {
  const { getPurchases, purchases, authState, logout } =
    useContext(AuthContext);
  const [clientSearch, setClientSearch] = useState("");
  const [saqueValor, setSaqueValor] = useState(150);
  const [load, setLoad] = useState(false);
  const [selectedContract, setSelectedContract] = useState(null);
  const [isRepurchase, setIsRepurchase] = useState(false);
  const [repurchaseContractId, setRepurchaseContractId] = useState("");
  const { showMessage } = useMessage();

  const handleSaqueChange = (e) => {
    let value = e.target.value;
    value = value.replace(/[^0-9,.]/g, "");
    value = value.replace(",", ".");
    setSaqueValor(value);
  };

  const fetchContracts = async () => {
    setLoad(true);
    try {
      await getPurchases(300, 0, "asc", null, clientSearch);
    } catch (e) {
      console.log(e);
    }
    setLoad(false);
  };

  const handleUnSelectContract = () => {
    setSelectedContract(null);
  };

  const realizeSaque = async () => {
    if (parseFloat(saqueValor) > selectedContract.avaliableToWithdraw) {
      showMessage("Valor indisponível para saque.", "warning");
      return;
    }

    const saque_data = {
      clientId: selectedContract.clientId,
      amountWithdrawn: parseFloat(saqueValor),
      contractId: selectedContract?.contract?.id || null,
      sponsorWithdraw: false,
    };

    setLoad(true);
    try {
      const url = isRepurchase && repurchaseContractId
        ? `${base_url}withdraw?forContractBuyingId=${repurchaseContractId}`
        : `${base_url}withdraw`;
      const response = await axios.post(url, saque_data, {
        headers: { Authorization: `Bearer ${authState.accessToken}` },
      });
      if (response.status === 201) {
        setModalNovoSaque(false);
        fetchSaques();
        showMessage(
          "Saque feito com sucesso, disponível em SAQUES PENDENTES",
          "success"
        );
      }
    } catch (error) {
      console.log(error);
      if (error.response?.status === 401 || error.response?.status === 403) {
        showMessage("Sessão Expirada.", "warning");
        logout();
      } else {
        showMessage("Erro: " + error.response?.data || error.message, "error");
      }
    } finally {
      setLoad(false);
    }
  };

  return (
    <S.ModalOverlay>
      <S.ModalContent>
        <Loading load={load} />
        <S.FecharModal>
          <S.ModalTitle>NOVO SAQUE</S.ModalTitle>
          <button onClick={() => setModalNovoSaque(false)}>
            <FaTimes />
          </button>
        </S.FecharModal>

        <S.Searching>
          <p>PESQUISE PELO CLIENTE</p>
          <div className="inputBoxSearch">
            <input
              placeholder="NOME OU CPF"
              value={clientSearch}
              onChange={(e) => setClientSearch(e.target.value)}
            />
            <button onClick={fetchContracts}>PESQUISAR</button>
          </div>

          <S.SearchedClients>
            <div className="columns">
              <span>ID</span>
              <span>NOME</span>
              <span>USUÁRIO</span>
              <span>CPF</span>
              <span>DISPONÍVEL</span>
            </div>
            {selectedContract && (
              <div className="rowSelected">
                <span>{selectedContract.contract.id}</span>
                <span>{selectedContract.clientName}</span>
                <span>{selectedContract.clientUsername}</span>
                <span>{selectedContract.clientCpfCnpj}</span>
                <span>
                  R${formatNumber(selectedContract.avaliableToWithdraw)}
                </span>
                <span
                  onClick={handleUnSelectContract}
                  style={{
                    color: "red",
                    cursor: "pointer",
                    textAlign: "center",
                  }}
                >
                  <FaTimes />
                </span>
              </div>
            )}
            <div className="tabelona">
              {!selectedContract &&
                purchases.map(
                  (contract, index) =>
                    contract.avaliableToWithdraw > 0 && (
                      <div
                        onClick={() => setSelectedContract(contract)}
                        className="row"
                        key={index}
                      >
                        <span>{contract.contract.id}</span>
                        <span>{contract.clientName}</span>
                        <span>{contract.clientUsername}</span>
                        <span>{contract.clientCpfCnpj}</span>
                        <span>
                          R${formatNumber(contract.avaliableToWithdraw || 0)}
                        </span>
                      </div>
                    )
                )}
            </div>
          </S.SearchedClients>
        </S.Searching>

        {selectedContract && (
          <S.SacarDoSelecionado>
            <span className="titulo">VALOR A SACAR</span>
            <input
              className="inputSacar"
              value={saqueValor}
              onChange={handleSaqueChange}
            />
            <S.RepurchaseToggle onClick={() => { setIsRepurchase(!isRepurchase); setRepurchaseContractId(""); }}>
              <S.RepurchaseCheckbox checked={isRepurchase} />
              É recompra?
            </S.RepurchaseToggle>
            {isRepurchase && (
              <input
                className="inputRepurchaseId"
                type="number"
                placeholder="ID do contrato"
                value={repurchaseContractId}
                onChange={(e) => setRepurchaseContractId(e.target.value)}
              />
            )}
            <button className="buttonSacar" onClick={realizeSaque}>
              SACAR
            </button>
          </S.SacarDoSelecionado>
        )}
      </S.ModalContent>
    </S.ModalOverlay>
  );
}
